import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  selectedContact: null,
  newThread: null,
  threadDetails: null,
}

const chatsSlice = createSlice({
  name: "chats",
  initialState,
  reducers: {
    setSelectedContact: (state, action) => {
      state.selectedContact = action.payload
    },
    setNewThread: (state, action) => {
      state.newThread = action.payload
    },
    setThreadDetails: (state, action) => {
      state.threadDetails = action.payload
    },
  },
})

export const { setSelectedContact, setNewThread, setThreadDetails } =
  chatsSlice.actions
export default chatsSlice.reducer
